import { c as _c } from "react/compiler-runtime";
import { Icon, TextPassage } from '@petsmart-ui/sparky';
import { decodeEntityString } from '@libs/algolia';
import { formatAutoshipFrequency } from '@libs/common-next';
import { ResponsivePicture } from '../ResponsivePicture';
import type { DrawerItem } from './model/useCartConfirmDrawer';
export const CartItem = t0 => {
  const $ = _c(25);
  const {
    name,
    image,
    autoshipFrequency,
    autoshipFrequencyUnitOfMeasure
  } = t0;
  let t1;
  if ($[0] !== autoshipFrequency || $[1] !== autoshipFrequencyUnitOfMeasure) {
    t1 = formatAutoshipFrequency(autoshipFrequency, autoshipFrequencyUnitOfMeasure);
    $[0] = autoshipFrequency;
    $[1] = autoshipFrequencyUnitOfMeasure;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const frequencyText = t1;
  let t2;
  if ($[3] !== autoshipFrequency) {
    t2 = autoshipFrequency && <Icon name="autoship-fill" className="basket-item__recurring-icon" size="md" data-testid="recurring-icon" />;
    $[3] = autoshipFrequency;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = image ?? "";
  const t4 = `${name} image`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: 80,
      height: 80
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4) {
    t6 = <ResponsivePicture src={t3} alt={t4} size={t5} />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t6) {
    t7 = <div className="basket-item__image-container">{t2}{t6}</div>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== autoshipFrequency || $[13] !== frequencyText) {
    t8 = autoshipFrequency && <TextPassage size="sm" className="basket-item__autoship-frequency" data-testid="autoship-frequency">Ships every {frequencyText}</TextPassage>;
    $[12] = autoshipFrequency;
    $[13] = frequencyText;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== name) {
    t9 = decodeEntityString(name);
    $[15] = name;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <TextPassage>{t9}</TextPassage>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <div className="basket-item__content">{t8}{t10}</div>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <li className="basket-item">{t7}{t11}</li>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};